import React, { useEffect } from 'react'

/**
 *
 * @param {object} props
 * @param {string} props.prompt
 * @param {function} props.setPrompt
 */
export default function PromptTextArea({ prompt, setPrompt }) {
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Tab') {
        if (event.preventDefault) {
          event.preventDefault()
        }
        setPrompt(prompt.concat('    '))
      }
      if (event.key === 'Enter') {
        if (event.preventDefault) {
          event.preventDefault()
        }
        setPrompt(prompt.concat('\n'))
      }
    }
    document.addEventListener('keydown', handleKeyPress)
    return () => document.removeEventListener('keydown', handleKeyPress)
  }, [prompt, setPrompt])

  return (
    <textarea
      className=" resize-none p-4 rounded my-4 w-full h-[150px] border border-solid border-[#222426] border-opacity-[0.15]  outline-none focus:border-[#85b7d9]"
      value={prompt}
      onChange={(e) => setPrompt(e.target.value)}
      placeholder="Supports nearly every language!"
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/PromptTextArea/index.js